export default __webpack_public_path__ + "static/media/googlexli.1d9765cd.png";